import * as Configuration from '../../app.constants.js';

CompanySelectionController.$inject = ['$scope', '$state', '$http', 'AlertingFactory'];
export function CompanySelectionController($scope, $state, $http, AlertingFactory) {

  $scope.submit = submit;

  init();

  function paramsToObject(entries) {
    const result = {}
    for (const [key, value] of entries) {
      result[key] = value;
    }
    return result;
  }

  function goToLogin(companyName) {

    $http.get(`${Configuration.constants.baseUrl}api/2.0/companies/${companyName}`)
      .then(response => {
        const companyInfo = response.data;
        const urlParams = new URLSearchParams(window.location.search);
        const entries = urlParams.entries();
        const params = paramsToObject(entries);
        const loginStateParams = {
          companyName: companyInfo.url_name
        };
        if (params.destStateName) {
          const paramsCopy = {
            ...params
          };
          delete paramsCopy.destStateName;
          loginStateParams.destState = {
            'name': params.destStateName,
            'params': {
              'companyId': companyInfo.id,
            },
            'qsArguments': paramsCopy
          }
        }
        $state.go('no-auth.company.login', loginStateParams);
      }, response => {
        const errorKey = response.status === 400 ? 'errors/unknown-company/error' : 'bug/unexpected-error';
        AlertingFactory.error(errorKey);
      });
  }

  function submit() {
    goToLogin($scope.companyName);
  }

  function init() {
    $scope.urlPrefix = Configuration.constants.frontendBaseUrl + '#/';
  }

}

